interface DropdownItem {
  name?: string;
  displayName?: string;
}

interface Props {
  dropdownItem: string | DropdownItem;
  isVisualOnly?: boolean;
}

export default function DropdownOption({ dropdownItem, isVisualOnly = false }: Props) {
  if (typeof dropdownItem === 'string') {
    const m2Patch = dropdownItem === 'm2' ? 'm²' : dropdownItem;
    if (isVisualOnly) {
      return <span key={dropdownItem}>{m2Patch}</span>;
    }
    return (
      <option key={dropdownItem} value={dropdownItem}>
        {m2Patch}
      </option>
    );
  }
  if (dropdownItem?.name && dropdownItem?.displayName) {
    const m2Patch = dropdownItem.displayName === 'm2' ? 'm²' : dropdownItem.displayName;

    if (isVisualOnly) {
      return <span key={dropdownItem.name}>{m2Patch}</span>;
    }
    return (
      <option key={dropdownItem.name} value={dropdownItem.name}>
        {m2Patch}
      </option>
    );
  }
  return null;
}
